import React from 'react';
import PropTypes from 'prop-types';

import { Loader } from '@atlas/components';
import { BasePopup, Icon, Label } from '@atlas/ui';

const AccountToppedUpPopup = ({ data }) => {
  const { message, title } = data;

  return (
    <BasePopup className="account-topped-up-popup">
      <div className="popup__content">
        <Icon className="popup__icon" height={32} name="success" width={32} />
        <Label className="popup__title" message={title} />
        <Label className="popup__text" message={message} />

        <div className="popup__loader">
          <Loader />
        </div>
      </div>
    </BasePopup>
  );
};

AccountToppedUpPopup.propTypes = {
  data: PropTypes.shape({
    message: PropTypes.string,
    title: PropTypes.string,
  }).isRequired,
};

export default AccountToppedUpPopup;
